import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Content.css';

const Content = () => {
    return (
        <section className="about-content-sec">
            <Container>
                <Row>
                    <Col md={12} lg={8} className="text-center">
                        <div className="section-title">
                            <h1>Our <span>Physiotherapy</span> Practice</h1>
                        </div>
                        <p className="w-75 m-auto content-inner">At the heart of our excellence is the commitment of our skilled physiotherapists. With a passion for healing and a wealth of expertise, our practitioners bring forth a practice defined by compassion, precision, and positive outcomes. Each session is a personalized journey, guided by our dedicated professionals who go above and beyond to ensure your optimal well-being. Experience the transformative power of our physiotherapy practice – where expertise meets genuine care for a healthier, happier you.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Content;